import { useState } from 'react'
import { Link, useLocation } from 'react-router'
import { useSessione } from '../servizi/sessione.tsx'
import { BottoneIcona } from './base.tsx'
import { IconaBusta, IconaChiudi } from './Icone.tsx'

/**
 * Riga delle caselle da associare (504), sopra la pagina, per chi gestisce le utenze.
 *
 * Quali caselle del vecchio server siano di un progetto, di un gruppo di persone o di una persona non
 * si ricava dal server: le associa CIDIS dal gestionale. Finche' ci sono caselle di gruppo attive senza
 * nessuno (vista com.casella_da_associare), la riga lo ricorda e porta a Posta → «Caselle condivise»,
 * gia' filtrata. Il numero arriva con /auth/io e si rilegge dopo ogni associazione; la riga non blocca
 * niente e si chiude con la crocetta fino al prossimo ingresso, come quella del secondo fattore.
 */
export function AvvisoCaselleDaAssociare() {
  const { io } = useSessione()
  const { pathname, search } = useLocation()
  const [chiuso, setChiuso] = useState(false)
  const quante = io?.caselleDaAssociare ?? 0
  // Sulla pagina a cui porta la riga non serve.
  const sullaPagina = pathname === '/posta' && search.includes('linguetta=gruppi')
  if (!quante || chiuso || sullaPagina) return null

  return (
    <div className="fattore-avviso invito" role="status">
      <IconaBusta />
      <p>
        <strong>
          {quante === 1
            ? 'C’è una casella di posta da associare'
            : `Ci sono ${quante} caselle di posta da associare`}
        </strong>{' '}
        a persone o progetti. <Link to="/posta?linguetta=gruppi&da_associare=1">Associale</Link>
      </p>
      <BottoneIcona icona={<IconaChiudi />} etichetta="Chiudi l’avviso delle caselle da associare"
                    onClick={() => setChiuso(true)} />
    </div>
  )
}
